import React from 'react';
import HomeMain from './HomeMain';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Home = () => {
  return (
    <>
      <Header />

      <HomeMain />

      <Footer />
    </>
  );
};

export default Home;
